export const fontSizeToFontMultiplier = (
  fontSize: "small" | "medium" | "large",
) => {
  switch (fontSize) {
    case "small":
      return 0.8;
    case "medium":
      return 1;
    case "large":
      return 1.2;
  }
};
